import { api } from './client'
import type { AppSettings } from '@/types'

export function fetchSettings(): Promise<AppSettings> {
  return api.get('/api/settings')
}

export function updateSettings(data: Partial<Omit<AppSettings, 'id' | 'createdAt'>>): Promise<void> {
  return api.patch('/api/settings', data)
}
